import { Http } from '@/model/Http.js'

export default class authorization extends Http {

  // 同步模板获取数据
  getSyncTemplateData(data){
    const url = 'api/open/template-pub/sync'
    return this.postAjaxByKfc(url, {
      ...data
    })
  }
}



// WEBPACK FOOTER //
// ./src/javaApi/kfc/authorization.js